import { TournamentsViewProps } from "../TournamentsView";
import { useTournamentsNavLinks } from "./hooks";
import TournamentsNav from "./TournamentsNav";

interface TournamentsNavContainerProps {
  mode?: TournamentsViewProps["mode"];
}
const TournamentsNavContainer: React.FC<TournamentsNavContainerProps> = ({
  mode
}) => {
  const { navLinks } = useTournamentsNavLinks({ mode });
  return <TournamentsNav navLinks={navLinks} />;
};

export default TournamentsNavContainer;
